<mat-expansion-panel>
  <mat-expansion-panel-header>
    Filtra
  </mat-expansion-panel-header>
  <form [formGroup]="filtersForm" novalidate>
    <div class="u-flex-full">
      <!-- Filtro Data -->
      <mat-form-field  class="u-full-width" formControlName="onlyCurrentTenant">
        <mat-label>Giorno di chiusura</mat-label>
        <input matInput [matDatepicker]="pickerFrom" formControlName="closure_date">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>
    </div>
    
    <div class="u-flex-full" style="justify-content: flex-end;">
      <button mat-raised-button [disabled]="filtersForm.pristine"
        (click)="applyFilters()" color="primary">Filtra</button>
      <button mat-icon-button *ngIf="!filtersForm.pristine" (click)="resetFilters()" matTooltip="Reset">
        <mat-icon>replay</mat-icon>
      </button>
    </div>
  </form>
</mat-expansion-panel>
